/**
 * @author Ketan Shetye
 * @created 2025-10-25
 * @description common pagination component
 */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { CommonPaginationData } from './common-pagination.component.model';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'wm-common-pagination',
  standalone: false,
  templateUrl: './common-pagination.component.html',
  styleUrls: ['./common-pagination.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CommonPaginationComponent {
  constructor(private paginatorIntl: MatPaginatorIntl) {
    this.paginatorIntl.itemsPerPageLabel = 'Rows per page';
  }

  private _data: CommonPaginationData = {
    variant: 'staff',
    totalPages: 0,
    currentPage: 0,
    pageSize: 10,
    pageSizeOptions: [10, 25, 100, 200],
    showRowsPerPage: false,
    showTotalRecords: false,
    visiblePages: [],
    canGoPrevious: false,
    canGoNext: false
  };

  @Input({ required: true })
  set data(value: CommonPaginationData) {
    this._data = {
      ...this._data,
      ...value
    };
  }

  get data(): CommonPaginationData {
    return this._data;
  }

  // Added by amisha on 05/07/2027 to let shared-table pages decide whether pagination stays in the tab order.
  // Reason: applicant flows needed focus styling updates without permanently removing keyboard access from pagination.
  @Input() disableKeyboardFocus = false;

  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() pageSelect = new EventEmitter<number>();
  @Output() first = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() last = new EventEmitter<void>();

  onPaginatorChange(event: PageEvent): void {
    if (event.pageSize !== this.data.pageSize) {
      this.pageSizeChange.emit(event.pageSize);
    }
  }
  onPageSizeChange(value: number): void {
    this.pageSizeChange.emit(value);
  }

  isCurrentPageSize(size: number | string): boolean {
    return Number(size) === Number(this.data.pageSize);
  }

  onPageSelect(page: number): void {
    this.pageSelect.emit(page);
  }
}
